var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import DoconChip from '../doconChip/doconChip';
import { BaseBox, FlexBox } from '../../shared/Element';
import { Heading3, Body1 } from '../doconHeadings/doconHeadings';
var Box = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  ", ", ", " {\n    margin-bottom: 12px;\n  }\n\n  ", " {\n    position: relative;\n  }\n"], ["\n  position: relative;\n\n  ", ", ", " {\n    margin-bottom: 12px;\n  }\n\n  ", " {\n    position: relative;\n  }\n"])), Heading3, Body1, FlexBox);
var DoconChips = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.disabled, disabled = _c === void 0 ? [] : _c, _d = _a.selected, selected = _d === void 0 ? [] : _d, _e = _a.vertical, vertical = _e === void 0 ? false : _e, _f = _a.gutter, gutter = _f === void 0 ? 8 : _f, marginBetweenTop = _a.marginBetweenTop, verticalSpace = _a.verticalSpace, children = _a.children, rootClassName = _a.rootClassName, props = __rest(_a, ["options", "disabled", "selected", "vertical", "gutter", "marginBetweenTop", "verticalSpace", "children", "rootClassName"]);
    return (React.createElement(Box, { className: rootClassName },
        React.createElement(Heading3, { fontWeight: 'medium', title: props.title }),
        React.createElement(Body1, { title: props.subTitle }),
        React.createElement(FlexBox, { vertical: vertical, gutter: gutter, verticalSpace: 0 },
            options.map(function (option) { return (React.createElement(DoconChip, __assign({ key: option.value, chip: option.value, label: option.label, marginBetweenTop: verticalSpace || marginBetweenTop, disabled: disabled.includes(option.value), isSelected: selected.includes(option.value) }, props))); }),
            children)));
};
var DoconChipSelect = function (_a) {
    var options = _a.options, name = _a.name, disabled = _a.disabled, action = _a.action, _b = _a.selected, selected = _b === void 0 ? [] : _b, props = __rest(_a, ["options", "name", "disabled", "action", "selected"]);
    function handleClick(_a) {
        var _b = _a.chip, chip = _b === void 0 ? '' : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.disabled, isDisabled = _d === void 0 ? false : _d;
        if (!isDisabled) {
            if (isSelected) {
                action && action({ name: name, value: selected.filter(function (e) { return e !== chip; }) });
            }
            else {
                action && action({ name: name, value: __spreadArray(__spreadArray([], __read(selected), false), [chip], false) });
            }
        }
    }
    return (React.createElement(DoconChips, __assign({ options: options, disabled: disabled, selected: selected, onClick: handleClick }, props)));
};
var DoconChipSingleSelect = function (_a) {
    var name = _a.name, options = _a.options, disabled = _a.disabled, action = _a.action, selected = _a.selected, props = __rest(_a, ["name", "options", "disabled", "action", "selected"]);
    function handleClick(_a) {
        var _b = _a.chip, chip = _b === void 0 ? '' : _b, _c = _a.disabled, isDisabled = _c === void 0 ? false : _c;
        if (!isDisabled) {
            action && action({ name: name, value: chip });
        }
    }
    return (React.createElement(DoconChips, __assign({ options: options, disabled: disabled, selected: selected ? [selected] : [], onClick: handleClick }, props)));
};
export { DoconChipSelect, DoconChipSingleSelect };
var templateObject_1;
